const addPropertiesToFeature = (feature, properties) => {
	return {
		...feature,
		properties: {
			...feature.properties,
			...properties,
			feature
		}
	};
};

export const toFeatures = (geometryOrFeatureOrFeatureCollection, properties = {}, $logger) => {
	if(geometryOrFeatureOrFeatureCollection.type === "FeatureCollection") {
		const featuresWithProperties = geometryOrFeatureOrFeatureCollection.features.map(f => addPropertiesToFeature(f, properties));

		return featuresWithProperties;
	}
		
	if(geometryOrFeatureOrFeatureCollection?.type === "Feature") {
		return [addPropertiesToFeature(geometryOrFeatureOrFeatureCollection, properties)];
	}

	const ex = new Error("Only Features and FeatureCollections are supported");
	$logger && $logger.exception(ex, "Invalid geometry type passed to toFeatures", { geometryOrFeatureOrFeatureCollection, properties });

	return undefined;
};

/**
 * Converts a data item's Geometries array into a GeoJSON FeatureCollection,
 * matching the same structure produced by decoding Shape.GeoJson.
 */
export function veslGeometriesToFeatureCollection(item) {
	const geoJsonFeatures = (item.Geometries || []).reduce((features, geom) => {
		if(geom?.Type?.Code !== "GEOJSON") {
			//we don't know what this is, skip it
			return features;
		}

		const geoJsonDefinition = geom.Definition;
		const additionalProperties = {
			id: item.Id,
			name: item.Name || item.Code
		};
		const newFeatures = toFeatures(geoJsonDefinition, additionalProperties);

		newFeatures !== undefined && features.push(...newFeatures);

		return features;
	}, []);

	return {
		type: "FeatureCollection",
		features: geoJsonFeatures
	};
}